import { render, staticRenderFns } from "./AbWysiwyg.vue?vue&type=template&id=9a61dece&scoped=true"
import script from "./AbWysiwyg.vue?vue&type=script&lang=js"
export * from "./AbWysiwyg.vue?vue&type=script&lang=js"
import style0 from "./AbWysiwyg.vue?vue&type=style&index=0&id=9a61dece&prod&scoped=true&lang=scss"
import style1 from "./AbWysiwyg.vue?vue&type=style&index=1&id=9a61dece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a61dece",
  null
  
)

export default component.exports